/* Helper functions to replace jQuery's slideUp and slideDown */
const slideUp = (target, duration = 300) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
};

const slideDown = (target, duration = 300) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
};

/* Ensure DOM is fully loaded before manipulating elements */
document.addEventListener('DOMContentLoaded', function() {

    /* ============================================================================
       Header animation scroll
    ============================================================================== */
    const header = document.querySelector('.shopify-section--header');
    if (header) {
        document.addEventListener('scroll', function() {
            if (window.scrollY > 180) {
                header.classList.add('Open');
            } else {
                header.classList.remove('Open');
            }
        });
    }

    /* ============================================================================
       Product description accordion
    ============================================================================== */
    const faqHeadings = document.querySelectorAll('.faqAccordion > dt > button');
    const faqContents = document.querySelectorAll('.faqAccordion > dd');

    if (faqHeadings.length > 0) {
        let isAnimating = false;

        // Init setup
        faqContents.forEach(content => {
            content.setAttribute('aria-hidden', 'true');
            content.style.display = 'none';
        });

        faqHeadings.forEach(heading => {
            heading.setAttribute('aria-expanded', 'false');
            const symbol = heading.querySelector('.symbol');
            if (symbol) symbol.classList.remove('is-open');
        });

        // Open first tab by default
        const firstHeading = faqHeadings[0];
        firstHeading.setAttribute('aria-expanded', 'true');
        const firstContent = firstHeading.parentElement.nextElementSibling;
        
        if (firstContent) {
            firstContent.setAttribute('aria-hidden', 'false');
            firstContent.style.display = 'block';
        }
        
        const firstSymbol = firstHeading.querySelector('.symbol');
        if (firstSymbol) firstSymbol.classList.add('is-open');

        // Click handler for accordions
        faqHeadings.forEach(heading => {
            heading.addEventListener('click', function(e) {
                e.preventDefault();
                if (isAnimating) return;
                isAnimating = true;

                const isOpen = this.getAttribute('aria-expanded') === 'true';
                if (isOpen) {
                    isAnimating = false;
                    return;
                }

                // Close all other tabs
                faqHeadings.forEach(h => {
                    h.setAttribute('aria-expanded', 'false');
                    const s = h.querySelector('.symbol');
                    if (s) s.classList.remove('is-open');
                });

                faqContents.forEach(c => {
                    if (c.style.display !== 'none') {
                        slideUp(c, 250);
                        c.setAttribute('aria-hidden', 'true');
                    }
                });

                // Open the clicked tab
                this.setAttribute('aria-expanded', 'true');
                const content = this.parentElement.nextElementSibling;
                const symbol = this.querySelector('.symbol');
                if (symbol) symbol.classList.add('is-open');

                if (content) {
                    slideDown(content, 250);
                    content.setAttribute('aria-hidden', 'false');

                    setTimeout(() => {
                        isAnimating = false;
                    }, 260);
                } else {
                    isAnimating = false;
                }
            });

            // Keyboard accessibility
            heading.addEventListener('keydown', function(event) {
                if (event.key === 'Enter' || event.keyCode === 13) {
                    this.click();
                }
            });
        });
    }

    /* ============================================================================
       Out of stock checker
    ============================================================================== */
    const spans = document.querySelectorAll('div.dmgWTv span');
    spans.forEach(span => {
        if (span.textContent.trim() === 'Tilapäisesti loppunut') {
            span.classList.add('out-of-stock');
        }
    });

    /* ============================================================================
       Avaa kielivalikko jos suomen ulkopuolelta
    ============================================================================== */
    const langMenuButton = document.querySelector('form.pristine > div > button.button.primary');
    if (langMenuButton) {
        langMenuButton.setAttribute('is', 'toggle-button');
        langMenuButton.setAttribute('aria-controls', 'product-template--16591778808016__product-content-db8fdf98-c1c6-4789-a2bf-512848060a7f-trust-1-drawer');
        langMenuButton.setAttribute('aria-expanded', 'false');
    }

    /* ============================================================================
       Smooth scroll kategoria description lue lisää
    ============================================================================== */
    const categoryAnchor = document.querySelector('a[href="#kategoria-tiedot"]');
    if (categoryAnchor) {
        categoryAnchor.addEventListener('click', function(e) {
            e.preventDefault();
            const targetElement = document.getElementById('kategoria-tiedot');
            if (targetElement) {
                window.scrollTo({
                    top: targetElement.getBoundingClientRect().top + window.scrollY - 120,
                    behavior: 'smooth'
                });
            }
        });
    }

    /* ============================================================================
       Offset when scrolling to reviews on product page
    ============================================================================== */
    document.querySelectorAll('a[href="#shopify-section-template--22829339574611__1722579898b5d84470"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.getElementById('shopify-section-template--22829339574611__1722579898b5d84470');
            if (target) {
                window.scrollTo({
                    top: target.getBoundingClientRect().top + window.scrollY - 90,
                    behavior: 'smooth'
                });
            }
        });
    });

});

/* ============================================================================
   Event Delegation Listeners 
   (Placed outside DOMContentLoaded to catch dynamic elements)
============================================================================== */
document.addEventListener('click', function(e) {
    
    // Focus on search input when search link is clicked
    if (e.target.closest('#focusButton')) {
        // Checking both IDs since your original code used both variants
        const searchInput = document.getElementById('ennakoiva-haku') || document.getElementById('ennakoivaHaku');
        if (searchInput) searchInput.focus();
    }

    // Hyvinvoinnin kulmakivet - Quiz Kit Next Button
    if (e.target.closest('#quiz-kit-question-next-button')) {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    // Kategoria description Open up lue lisää
    const readMoreBtn = e.target.closest('.read-more');
    if (readMoreBtn) {
        e.preventDefault();
        const content = document.querySelector('.collection-description-part-2');
        
        if (content) {
            if (content.classList.contains('open')) {
                content.classList.remove('open');
                readMoreBtn.textContent = 'Lue lisää';

                const categoryTarget = document.getElementById('kategoria-tiedot');
                if (categoryTarget) {
                    window.scrollTo({
                        top: categoryTarget.getBoundingClientRect().top + window.scrollY - 120,
                        behavior: 'smooth'
                    });
                }
            } else {
                content.classList.add('open');
                readMoreBtn.textContent = 'Sulje';
            }
        }
    }
});

/* SOLWE: Fix for reviews.io to anchor rating snippet to reviews widget.
   The app's anchorToReviewsWidget binds its click handler to only the first .ruk_rating_snippet
   in the DOM, which is the one in the sticky form, so the stars in .product__info need their own. */
document.addEventListener('DOMContentLoaded', function () {
  var snippet = document.querySelector('.product__info .ruk_rating_snippet');
  if (!snippet) return;
  snippet.style.cursor = 'pointer';
  snippet.addEventListener('click', function () {
    var widget = document.querySelector('[id^="ReviewsWidget-"]');
    if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});

/* SOLWE: Product card stars -> reviews on the product page.
   Cards link to /products/<handle>#shopify-product-reviews, but that id does not exist on pages with
   the Reviews.io widget, so the product page opened at the top. A click on card stars sets a short-lived
   flag; the product page then scrolls to the Reviews.io widget once it has rendered. */
(function () {
  var FLAG = 'solwe-scroll-to-reviews';
  var MAX_FLAG_AGE = 15000;
  var MAX_WAIT = 10000;

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.product-item .ruk_rating_snippet')) return;
    try { sessionStorage.setItem(FLAG, String(Date.now())); } catch (err) {}
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    var flagged = false;
    try {
      var ts = parseInt(sessionStorage.getItem(FLAG), 10);
      flagged = !!ts && Date.now() - ts < MAX_FLAG_AGE;
      sessionStorage.removeItem(FLAG);
    } catch (err) {}
    var hashed = location.hash === '#shopify-product-reviews' && !document.getElementById('shopify-product-reviews');
    if (!flagged && !hashed) return;

    var interacted = false;
    ['wheel', 'touchstart', 'keydown'].forEach(function (name) {
      window.addEventListener(name, function () { interacted = true; }, { once: true, passive: true });
    });

    var started = Date.now();
    var timer = setInterval(function () {
      var widget = document.querySelector('[id^="ReviewsWidget-"]');
      if (widget && widget.offsetHeight > 100) {
        clearInterval(timer);
        widget.scrollIntoView({ behavior: 'instant', block: 'start' });
        // images and the widget itself shift the layout after the first scroll, so correct once
        setTimeout(function () {
          if (!interacted) widget.scrollIntoView({ behavior: 'instant', block: 'start' });
        }, 1000);
      } else if (Date.now() - started > MAX_WAIT) {
        clearInterval(timer);
      }
    }, 150);
  });
})();

/* Start Globo Popup on pageload (Commented out as in original)
window.addEventListener('load', function() {
    const popupForm = document.getElementById('globo-popup-form');
    if (popupForm) popupForm.click();
});
*/